module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "idThumPan",
    staticStyle: {
      "float": "left",
      "background": "#ffffff"
    }
  }, [_c('div', {
    ref: "idThum",
    staticStyle: {
      "border": "0px solid blue"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68ef6e98","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/ImgThum.vue
// module id = 780
// module chunks = 1